export const fieldNameOfferIBVulcan = 'offerIBVulcan';

export const pricingFieldTelusBusinessInternetBackup = [fieldNameOfferIBVulcan];
